import React, { useCallback, useState } from "react";
import type { BeforeAfterPanel, DocImage } from "../../data/caseStudies";
import { DocLightbox } from "./DocLightbox";
import { TallImage } from "./TallImage";
import { BODY, H2, H3 } from "../../utils/typography";
type BeforeAfterProps = {
  panels: BeforeAfterPanel[];
};
export function BeforeAfter({
  panels
}: BeforeAfterProps) {
  const [open, setOpen] = useState<DocImage | null>(null);
  const close = useCallback(() => setOpen(null), []);
  return <section aria-labelledby="before-after-heading" data-id="element-36" data-mp="1ozbf915ztzpx">
      <h2 id="before-after-heading" className={`${H2} text-espresso`} data-id="element-37" data-mp="1ozun1p1xj7q8">
        Before / After
      </h2>

      <div className="mt-10 grid grid-cols-1 gap-14 md:grid-cols-2 md:gap-8" data-id="element-38" data-mp="1ype9t5srjlqd">
        {panels.map(panel => <article key={panel.label} className="flex flex-col" data-id="element-39" data-mp="11aa77f12oql6">
            <span className="self-start rounded-full bg-espresso px-4 py-1.5 text-xs font-medium uppercase tracking-wide text-cream" data-id="element-40" data-mp="117wa70mu14az">
              {panel.label}
            </span>
            <h3 className={`mt-5 ${H3} text-espresso`} data-id="element-41" data-mp="1p35141dnvlzu">
              {panel.headline}
            </h3>
            <div className={`mt-4 space-y-4 ${BODY} text-espresso/75`} data-id="element-42" data-mp="1k5btr50mglxz">
              {panel.body.map(p => <p key={p} data-id="element-43" data-mp="1fbqrv1vwr7ti">{p}</p>)}
            </div>
            <div className="mt-auto pt-8" data-id="element-44" data-mp="1bbgpdz7bqzje">
              <TallImage doc={{
            label: panel.label,
            caption: panel.headline,
            image: panel.image
          }} onOpen={setOpen} data-id="element-45" data-mp="16d5edl5amizl" />
            </div>
          </article>)}
      </div>

      <DocLightbox doc={open} onClose={close} data-id="element-46" data-mp="weftdji3oif4" />
    </section>;
}